export const newBrandingOldEvent = (eid) => {
    const eids = [30502,41256,41257, 27950];
    return eids.includes(parseInt(eid));
};

export const isAccountExcludedFromSystemMessagePopup = (pid) => {
    const excludedAccounts = [13247];
    return excludedAccounts.includes(parseInt(pid));
};

export const isBillingAccount = (pid) => {
    const billingAccounts = [1142];
    return billingAccounts.includes(parseInt(pid));
};